<template>
  <div v-if="loading" class="text-center mt-5 font-2xl text-muted">
    <i class="fal fa-spinner fa-spin" /> Audit Data Loading...
  </div>

  <div v-else class="animated fadeIn">
    <basic-heading title="Audit Trail" class="mb-3">
      <template #right-content>
        <header-button-group :button_config="button_config">
        </header-button-group>
      </template>
    </basic-heading>

    <permission-alert-gate :permissions="'read sample'">
      <template #gated-content>
        <sample-card :sample="sample" />

        <div>
          <h3>
            Change Log
            <b-button class="float-right" variant="success" :to="`/samples/${sample_id}/audit-trail-history`">
              View History
            </b-button>
          </h3>
        </div>
        <AuditChangeLogTable
          :model="sample"
        />

        <h3>Relations</h3>
        <AuditRelationTable
          :model="sample"
        />
      </template>
    </permission-alert-gate>
  </div>
</template>

<script>
import ToastNotifications from '@/components/shared/mixins/ToastNotifications'
import PermissionAlertGate from "@/components/permission/PermissionAlertGate"
import SampleCard from '@/components/lab/sample/SampleCard'
import AuditChangeLogTable from '@/components/shared/audit/AuditChangeLogTable'
import AuditRelationTable from '@/components/shared/audit/AuditRelationTable'
import BasicHeading from '@/components/shared/BasicHeading'
import HeaderButtonGroup from '@/components/shared/headerbuttons/HeaderButtonGroup'
import SampleModel from '@/models/lab/SampleModel'

export default {
  name: "SampleAuditTrail",
  components: {
    PermissionAlertGate,
    SampleCard,
    AuditChangeLogTable,
    AuditRelationTable,
    BasicHeading,
    HeaderButtonGroup
  },
  mixins: [ToastNotifications],
  data () {
    return {
      loading: true,
      sample: null,
      sample_id: this.$route.params.sample_id || null
    };
  },
  computed: {
    button_config() {
      return {
        buttons: [
          {
            icon: "fa-eye",
            linkto: `/samples/${this.sample_id}`,
            title: "View sample",
            variant: "info",
          }
        ]
      }
    },
  },
  async created () {
    this.loading = true

    this.sample = new SampleModel({ id: this.sample_id })

    const params = {}
    params.connection = ['auditCreatedBy', 'auditUpdatedBy']

    this.sample.fetch({ params }).then(() => {
      this.loading = false
    })
  },
}
</script>
